import React, { Component } from 'react'
import Aux from '../../../../../hoc/Auxiliary/Auxiliary'
import {
  AreaChart,
  Label,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Area,
  ResponsiveContainer
} from 'recharts'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'

class ForceRankChart extends Component {
  state = {
    gradeData: [],
    grade: [],
    adjust_grade: []
  }

  static getDerivedStateFromProps = (props, state) => {
    if (props?.gradeData && props?.gradeData !== state.gradeData) {
      return {
        gradeData: props.gradeData
      }
    }
    if (props?.adjust_grade && props?.adjust_grade !== state.adjust_grade) {
      return {
        adjust_grade: props.adjust_grade
      }
    }
    return null
  }

  render() {
    let data = []

    // if (this.state.adjust_grade) {
    //   data.push({ test: this.state.adjust_grade, test2: this.state.gradeData })
    // }

    // this.props.gradeData.map(i => {
    //   this.props.adjust_grade.map(j => {
    //     if (i.value_list_name === j.adjust_grade) {
    //       if (i.amount !== j.total) {
    //         data.push({
    //           grade: i.value_list_name,
    //           total: j.total ? j.total : 0
    //         })
    //       }
    //     }
    //   })
    // })

    data = this.state.adjust_grade

    return (
      <Aux>
        <ResponsiveContainer>
          <AreaChart
            width={500}
            height={400}
            data={data}
            margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
            <defs>
              <linearGradient id='color' x1='0' y1='0' x2='0' y2='1'>
                <stop offset='5%' stopColor='#98cad3' stopOpacity={0.8} />
                <stop offset='95%' stopColor='#98cad3' stopOpacity={0} />
              </linearGradient>
            </defs>
            <XAxis dataKey='adjust_grade'>
              <Label value={this.props.translate('grade')} offset={0} position='insideBottom' />
            </XAxis>
            <YAxis>
              <Label value={this.props.translate('adjust')} angle={-90} position='insideLeft' />
            </YAxis>

            <CartesianGrid strokeDasharray='3 5' />
            <Tooltip />
            <Area
              type='monotone'
              dataKey='total'
              stroke='#98cad3'
              fillOpacity={1}
              fill='url(#color)'
            />
          </AreaChart>
        </ResponsiveContainer>
      </Aux>
    )
  }
}

export default withTranslate(ForceRankChart)
